import * as React from "react"
import { Container } from "react-bootstrap"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import Table from "../../components/Table"

import useSikhTemplesData from "../../hooks/useSikhTemplesData.js"

const SikhTemplesPage = ({location}) => {
	const columns = [
		{ name: "English Name", key: "english_name_I" },
		{ name: "Punjabi Name", key: "chinese_name_I" },
		{ name: "Address", key: "full_address" },
	]

	const data = useSikhTemplesData()

	return (
		<Layout location={location}>
			<Seo title="Index of Sikh Temples" />

			<Container>
				<h1>Sikh Temples</h1>

				<Table
					columns={columns}
					data={data}
					paginationSize={50}
					routeLink={() => "/map"}
					routeState={({ id }) => ({ id })}
				/>

			</Container>

		</Layout>
	)
}

export default SikhTemplesPage
